module.exports = __webpack_public_path__ + "img/wxqun.8439fbfd.png";